export enum ListExternalApplicationsEnum {
  Ressifnet = 'RESSIFNET',
  Inception = 'INCEPTION',
  Daisy = 'DAISY'
}